import React, { Component } from 'react';
import MobileActionStepsList from './MobileActionStepsList';

class MobileActionStepsViewV2 extends Component {
  constructor() {
    super();
    this.state = {
      hasExpand: false,
      expanded: false,
    };
    this.setExpanded = this.setExpanded.bind(this);
    this.hasExpand = this.hasExpand.bind(this);
    this.setHasExpand = this.setHasExpand.bind(this);
    this.onActionStepsUlRef = this.onActionStepsUlRef.bind(this);
    this.onActionStepsSetChanged = this.onActionStepsSetChanged.bind(this);
    this.onRequestAnimationFrame = this.onRequestAnimationFrame.bind(this);

    this.actionStepsUlSet = {};
  }

  componentDidMount() {
    this.onRequestAnimationFrame();
  }

  componentDidUpdate() {
    this.onActionStepsSetChanged();
  }

  componentWillUnmount() {
    this.cancelRaf = true;
  }

  onRequestAnimationFrame() {
    if (this.cancelRaf) {
      return;
    }
    this.onActionStepsSetChanged();
    window.setTimeout(this.onRequestAnimationFrame, 100);
  }

  onActionStepsSetChanged() {
    const hasExpand =
      Object.keys(this.actionStepsUlSet)
        .filter(key => this.actionStepsUlSet[key])
        .some((key) => {
          const actionStepsUl = this.actionStepsUlSet[key];
          const EPSILON = 2;
          return (
            actionStepsUl.offsetHeight < actionStepsUl.scrollHeight - EPSILON ||
            actionStepsUl.offsetWidth < actionStepsUl.scrollWidth - EPSILON
          );
        }) || this.state.expanded;
    if (this.state.hasExpand !== hasExpand) {
      this.setState({
        hasExpand,
      });
    }
  }

  onActionStepsUlRef(actionStepsUl, uuid) {
    this.actionStepsUlSet[uuid] = actionStepsUl;
    this.onActionStepsSetChanged();
  }

  setExpanded(expanded) {
    this.setState({
      expanded,
    });
  }

  setHasExpand(hasExpand) {
    this.setState({
      hasExpand,
    });
  }

  hasExpand() {
    return this.state.hasExpand;
  }

  render() {
    const p = this.props;
    if (p.isCurrentPlan) {
      return null;
    }
    return (
      <div>
        <div className="mobile-consumer-heading-separator">Action Steps</div>
        <MobileActionStepsList
          hasExpand={this.state.hasExpand}
          onActionStepsUlRef={this.onActionStepsUlRef}
          title={p.leftTitle}
          emptyStateText="No action steps."
          buttonText={p.leftButtonText}
          onAdd={p.onAddActionSteps(p.clientId, p.fpId, p.goalId, p.actionSteps.length)}
          onReset={p.onResetActionSteps(p.clientId, p.fpId, p.goalId)}
          onDeleteItem={p.onDeleteActionStep(p.clientId, p.fpId, p.goalId)}
          onChangeStatus={p.onChangeActionStepStatus(p.clientId, p.fpId, p.goalId)}
          items={p.actionSteps}
          isExpanded={this.state.expanded}
          isAdding={p.isAddingActionStep}
          addIcon={p.addActionStep.Icon}
          addText={p.addActionStep.Text}
          new={p.addActionStep}
          setIcon={p.setActionStepIcon(p.clientId, p.fpId, p.goalId)}
          setText={p.setActionStepText(p.clientId, p.fpId, p.goalId)}
          onDoneAdding={p.onDoneAddingActionStep(p.clientId, p.fpId, p.goalId)}
          onCancelAdding={p.onCancelAddingActionStep(p.clientId, p.fpId, p.goalId)}
        />
        <div className="mobile-consumer-heading-separator">Suggestions</div>
        <MobileActionStepsList
          hideReset
          hasExpand={this.state.hasExpand}
          onActionStepsUlRef={this.onActionStepsUlRef}
          title={p.rightTitle}
          emptyStateText="No suggestions."
          buttonText={p.rightButtonText}
          onAdd={p.onAddSuggestions(p.clientId, p.fpId, p.goalId)}
          onReset={p.onResetSuggestions(p.clientId, p.fpId, p.goalId)}
          onDeleteItem={p.onDeleteSuggestion(p.clientId, p.fpId, p.goalId)}
          onChangeStatus={() => {}}
          items={p.suggestions}
          isExpanded={this.state.expanded}
          isAdding={p.isAddingSuggestion}
          addIcon={p.addSuggestion.Icon}
          addText={p.addSuggestion.Text}
          new={p.addSuggestion}
          setIcon={p.setSuggestionIcon(p.clientId, p.fpId, p.goalId)}
          setText={p.setSuggestionText(p.clientId, p.fpId, p.goalId)}
          onDoneAdding={p.onDoneAddingSuggestion(p.clientId, p.fpId, p.goalId)}
          onCancelAdding={p.onCancelAddingSuggestion(p.clientId, p.fpId, p.goalId)}
        />
      </div>
    );
  }
}

export default MobileActionStepsViewV2;
